module.exports = "/_next/static/images/img__card-3-touch-4413b1b65c8701dd49b522216c598f8a.png";